<div class="benchmark-runs-container">
  <div class="page-header">
    <div class="page-title">
      <p-button
        icon="pi pi-arrow-left"
        severity="secondary"
        [text]="true"
        [rounded]="true"
        pTooltip="Назад в редактор бенчмарка"
        i18n-pTooltip="@@benchmarks.runs.back"
        (click)="goBack()"
        i18n-ariaLabel="@@benchmarks.runs.back"
        ariaLabel="Назад в редактор бенчмарка">
      </p-button>
      <h2 i18n="@@benchmarks.runs.title">История прогонов</h2>
      @if (benchmark(); as b) {
        <div class="benchmark-summary">
          <strong>{{ b.title }}</strong>
          <p-tag
            [value]="(b.model_type_code || '').toUpperCase()"
            [rounded]="true"
            severity="info">
          </p-tag>
        </div>
      }
    </div>
    <div class="page-actions">
      <p-button
        icon="pi pi-refresh"
        severity="secondary"
        [outlined]="true"
        [disabled]="isLoadingRuns() || !benchmarkId()"
        (click)="benchmarkId() && loadRuns(benchmarkId()!)"
        i18n-label="@@benchmarks.runs.refresh"
        label="Обновить">
      </p-button>
    </div>
  </div>

  @if (isLoadingBenchmark() && !benchmark()) {
    <div class="loading-container">
      <p-progressSpinner styleClass="loading-spinner"></p-progressSpinner>
    </div>
  } @else {
    @if (isLoadingRuns() && runs().length === 0) {
      <div class="loading-container">
        <p-progressSpinner styleClass="loading-spinner"></p-progressSpinner>
      </div>
    } @else {
      <div class="table-container">
        <p-table [value]="runs()" styleClass="runs-table" [scrollable]="true">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 6rem;" i18n="@@benchmarks.runs.col.status">Status</th>
              <th style="width: 6rem;" i18n="@@benchmarks.runs.col.trigger">Trigger</th>
              <th i18n="@@benchmarks.runs.col.items">Items (versions)</th>
              <th style="width: 11rem;" i18n="@@benchmarks.runs.col.created">Created</th>
              <th style="width: 11rem;" i18n="@@benchmarks.runs.col.recorded">Finished</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-run>
            <tr class="run-row" (click)="openRunDetails(run.id)">
              <td>
                <p-tag
                  [value]="run.status"
                  [severity]="runStatusSeverity(run.status)"
                  [rounded]="true">
                </p-tag>
              </td>
              <td>
                <p-tag
                  [value]="runTriggerLabel(run.trigger)"
                  severity="secondary"
                  [rounded]="true">
                </p-tag>
              </td>
              <td>
                <div class="counters-row">
                  <div class="counter">
                    <span class="dim" i18n="@@benchmarks.runs.count.total">Total</span>
                    <strong>{{ run.item_count ?? 0 }}</strong>
                  </div>
                  @if ((run.completed_count ?? 0) > 0) {
                    <div class="counter counter-success">
                      <i class="pi pi-check-circle"></i>{{ run.completed_count }}
                    </div>
                  }
                  @if ((run.running_count ?? 0) > 0) {
                    <div class="counter counter-warn">
                      <i class="pi pi-spin pi-spinner"></i>{{ run.running_count }}
                    </div>
                  }
                  @if ((run.failed_count ?? 0) > 0) {
                    <div class="counter counter-danger">
                      <i class="pi pi-times-circle"></i>{{ run.failed_count }}
                    </div>
                  }
                  @if ((run.stopped_count ?? 0) > 0) {
                    <div class="counter counter-secondary">
                      <i class="pi pi-stop-circle"></i>{{ run.stopped_count }}
                    </div>
                  }
                  @if ((run.initial_count ?? 0) > 0) {
                    <div class="counter">
                      <i class="pi pi-clock"></i>{{ run.initial_count }}
                    </div>
                  }
                </div>
                @if (run.error_message) {
                  <div class="run-error">
                    <i class="pi pi-exclamation-triangle"></i>
                    {{ run.error_message }}
                  </div>
                }
              </td>
              <td>{{ formatDate(run.created_at) }}</td>
              <td>{{ formatDate(run.recorded_at) }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5" style="text-align: center;" i18n="@@benchmarks.runs.empty">
                Прогонов ещё не было. Запустите первый из редактора бенчмарка или списка.
              </td>
            </tr>
          </ng-template>
        </p-table>

        @if (runsNextCursor()) {
          <div class="load-more-row">
            <p-button
              icon="pi pi-chevron-down"
              severity="secondary"
              [outlined]="true"
              [loading]="isLoadingRuns()"
              (click)="loadMoreRuns()"
              i18n-label="@@benchmarks.runs.loadMore"
              label="Load more">
            </p-button>
          </div>
        }
      </div>
    }
  }

  <app-benchmark-run-details-drawer
    [visible]="drawerVisible()"
    [runId]="selectedRunId()"
    (visibleChange)="onDrawerVisibleChange($event)">
  </app-benchmark-run-details-drawer>
</div>
